export default "__VITE_ASSET__18830fd6__"